import { useExamDefinitionAuthoring } from "@repo/data-store";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { CatalogDefinition, ExamDefinitionRevise } from "@/features/catalog";
import { examDefinitionUrlFromRouteId } from "@/features/catalog/lib/exam-definition-route";
import { canWriteExamDefinitions } from "@/features/catalog/lib/exam-permissions";

export const Route = createFileRoute("/catalog/exams/$examId_/edit")({
  beforeLoad: ({ context }) => {
    if (!context.permissions.canRead("Questionnaire")) throw redirect({ to: "/catalog/exams" });
  },
  component: EditExamDefinitionComponent,
});

function EditExamDefinitionComponent() {
  const { examId } = Route.useParams();
  const { permissions } = Route.useRouteContext();
  const navigate = useNavigate();
  const examDefinition = useExamDefinitionAuthoring(examDefinitionUrlFromRouteId(examId));
  const navigateBack = useCallback(
    () =>
      navigate({
        to: "/catalog/exams/$examId",
        params: { examId },
      }),
    [examId, navigate],
  );

  if (!examDefinition) {
    return <CatalogDefinition.NotFound label="Exam" backTo="/catalog/exams" backLabel="Back to exams" />;
  }

  return (
    <ExamDefinitionRevise
      key={examId}
      definition={examDefinition}
      canEdit={canWriteExamDefinitions(permissions)}
      onDone={navigateBack}
      onCancel={navigateBack}
    />
  );
}
